export default "__VITE_ASSET__Dx6ho5zk__"